import isPropsNegative from '@anm/helpers/object/isPropsNegative';
import useMemorizeSize from '@anm/hooks/dom/useMemorizeSize';
import useIntersectionObserver from '@anm/hooks/useIntersectionObserver';
import { useMemo, FC } from 'react';

export type VirtualItemProps = { height?: number; canShowChildren?: boolean };

const VirtualItem: FC<VirtualItemProps> = ({ canShowChildren, children }) => {
  const [scrollAreaRef, inView] = useIntersectionObserver();
  const { width, height } = useMemorizeSize(scrollAreaRef);
  const showChildren = !!(canShowChildren || inView || isPropsNegative({ width, height }));

  return useMemo(() => {
    return (
      <div ref={scrollAreaRef} style={{ minWidth: width, minHeight: height }}>
        {showChildren && children}
      </div>
    );
  }, [width, height, showChildren, children]);
};

export default VirtualItem;
